export const fractionsSymbols: Array<String> = [
  '½', '⅓', '⅔', '¼', '¾',
  '⅕', '⅖', '⅗', '⅘', '⅙', '⅚',
  '⅐', '⅛', '⅜', '⅝', '⅞', '⅑', '⅒',
];
